import { render } from "./ToggleSwitch.vue?vue&type=template&id=28a5c18e&scoped=true&ts=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=28a5c18e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a5c18e"]])

export default __exports__